<template>
  <hic-dialog :title="`${type}医嘱`" :visible="visible" @open="open" @close="cancel" width="30rem" top="10vh">
    <el-form :model="entity" ref="form" :rules="rules" label-width="80px" class="right-pad">
      <template v-if="type == '离院'">
        <h2 class="center warning">患者治疗结束，办理出院手续！</h2>
        <el-form-item label="离院方式" prop="code">
          <hic-dict-selector dict-type="IpLeaveMode" v-model="entity.code" @change="entChange" placeholder="请选择" is-enum></hic-dict-selector>
        </el-form-item>
        <el-form-item v-if="!setting.isSimple" label="患者状况" prop="symptom">
          <hic-dict-selector dict-type="IpLeaveStatus" v-model="entity.symptom" placeholder="请选择" is-enum></hic-dict-selector>
        </el-form-item>
        <el-form-item label="情况说明" prop="detail">
          <el-input type="textarea" size="small" v-model="entity.detail" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="离院时间" prop="startTime">
          <el-date-picker v-model="entity.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" size="small" placeholder="选择日期" fo style="width: 100%"> </el-date-picker>
        </el-form-item>
      </template>
      <template v-else>
        <h2 class="center warning">将患者转往其他科室！</h2>
        <el-form-item label="目标科室" prop="code">
          <hic-dict-selector dict-type="Dept" v-model="entity.code" @change="entChange" placeholder="请选择" is-op style="width: 100%"></hic-dict-selector>
        </el-form-item>
        <el-form-item label="转科原因" prop="detail">
          <el-input type="textarea" size="small" v-model="entity.detail" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="转科时间" prop="startTime">
          <el-date-picker v-model="entity.startTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" size="small" placeholder="选择日期" style="width: 100%"> </el-date-picker>
        </el-form-item>
      </template>
    </el-form>
    <template slot="footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="submit" class="left-pad">确 定</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      hospitalization: Object,
      type: String,
      visible: Boolean,
    },
    data() {
      return {
        entity: {},
        rules: {
          code: [{ required: true, message: "请选择离院方式", trigger: "change" }],
          symptom: [{ required: true, message: "请选择患者状态", trigger: "change" }],
          startTime: [{ required: true, message: "请选择", trigger: "change" }],
        },
      };
    },
    computed: {
      ...mapGetters(["user", "setting"]),
    },
    methods: {
      open() {
        if (this.$refs.form) this.$refs.form.resetFields();
        this.entity = {
          type: this.type,
          term: "临时",
          hospitalizationId: this.hospitalization.id,
          ipNo: this.hospitalization.ipNo,
          bedNo: this.hospitalization.bedNo,
          patientCode: this.hospitalization.patientCode,
          patientName: this.hospitalization.patientName,
          deptCode: this.hospitalization.deptCode,
          doctorCode: this.user.code,
          doctorName: this.user.name,
          state: "草稿",
          startTime: this.$utils.Dt.now(),
          code: null,
          name: null,
          price: null,
          detailObj: null,
          detail: null,
          claimType: null,
        };
      },
      entChange(code, obj) {
        this.entity.name = obj.name;
      },
      cancel() {
        this.$emit("update:visible", false);
      },
      submit() {
        this.$refs.form.validate((valid) => {
          if (!valid) return;
          if (this.type === "离院") {
            this.entity.content = `患者${this.entity.name}离院`;
          } else {
            this.entity.content = `患者转科至${this.entity.name}`;
          }
          this.$emit("ok", this.entity);
          this.cancel();
        });
      },
    },
  };
</script>
